import React, { Component } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import './SundaySchool.css';
export class SundaySchool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: []
    };
  }

  componentDidMount() {
    fetch("/data/sundayschool.json")
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result.documents
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Loading...</div>;
    } else {
      return <div>
      <h3>Sunday School Resources</h3>
      <br />
      <div>
        <Card>
              <Card.Title>
                Class Sunday @ 1:10pm - 2:pm
              </Card.Title>
              <Card.Body>
                  <h4>
                      Meeting every 1st and 3rd Sunday of each month.
                  </h4>            
              </Card.Body>              
        </Card>
      </div>
      <div>
        <Card>
              <Card.Title>
                Document Resources
              </Card.Title>
              <Card.Body>
                <ListGroup>
                {items.map(item => (
                  <SundaySchoolLink
                    title={item.title}
                    link={item.link}/>
                ))}
                </ListGroup>
              </Card.Body>              
        </Card>
      </div>
    </div>
    }
  }
}

export class SundaySchoolLink extends Component {
  render() {
      return <ListGroup.Item>
      <a href={this.props.link} alt={this.props.title} target="_blank" rel="noopener noreferrer">
            <h5>
            {this.props.title}
            </h5>
        </a>  
      </ListGroup.Item>;
  }
}

export class SundaySchoolItem extends Component {
    render() {
      return <tr id={this.props.sdate} className={IsLessThanDaysAway(this.props.sdate, 7) ? "thisWeek" : null}>
          <td>{addDays(new Date(this.props.sdate), -6).toLocaleDateString('en-US', { month: 'short', day: 'numeric'})}</td>
          <td>{new Date(this.props.sdate).toLocaleDateString('en-US', { month: 'short', day: 'numeric'})}</td>
          <td><a href={'https://www.churchofjesuschrist.org/study/manual/come-follow-me-for-individuals-and-families-book-of-mormon-2020/' + this.props.lesson + '?lang=eng'} alt={this.props.topic}>{this.props.topic}</a></td>
          <td>{getClass(this.props.classId)}</td>
      </tr>
    }

  }

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function getClass(classNumber)
  {
      var className = classNumber;
      if (classNumber === "1")
      {
        className = 'Sunday School';
      }
      if (classNumber === "2")
      {
        className = 'RS/EQ-YM/YW';
      }
      return className;
  }

  function IsLessThanDaysAway(date, days)
  {
    var today = new Date();
    today.setHours(0,0,0,0); //set to midnight
    var sunday = new Date(date);
    var diff = sunday - today;
    if (diff >= 0)
    {
      var daysDiff = diff / (1000*60*60*24);
      if (daysDiff < days)
      {
        return true;
      }
    }
    return false;
  }

export default (SundaySchool);
